import { configureStore } from '@reduxjs/toolkit';
import userReducer from './userSlice';
import workingOnReducer from './workingOnSlice';

const store = configureStore({
  reducer: {
    user: userReducer,
    workingOn: workingOnReducer,
  },
});

export default store;
